import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import OverflowTooltip from './OverflowTooltip';

interface SiteChipProps {
  siteNames: string[];
  totalSiteCount: number;
  siteRestricted: boolean;
}

const labelFor = (props: SiteChipProps) => {
  if (!props.siteRestricted) return 'All sites';
  if (props.siteNames.length === 0) return 'No sites';
  if (props.siteNames.length === 1) return props.siteNames[0];

  return `${props.siteNames.length} of ${props.totalSiteCount}`;
};

export const SiteChip = (props: SiteChipProps) => {
  const label = labelFor(props);
  const listed = props.siteRestricted && props.siteNames.length > 1;
  const empty = props.siteRestricted && props.siteNames.length === 0;

  const indicator = <div
    className="d-inline-flex align-items-center gap-1 mw-100 small"
    tabIndex={listed ? 0 : undefined}
    aria-label={listed ? `${label}: ${props.siteNames.join(', ')}` : undefined}>
    <i className={`bi-geo-alt-fill flex-shrink-0 ${empty ? 'text-warning' : 'text-muted'}`} aria-hidden="true" />
    {listed
      ? <span className="text-truncate" style={{ borderBottom: '1px dotted currentColor', cursor: 'default' }}>{label}</span>
      : <OverflowTooltip className="mb-0" text={label} />}
  </div>;

  if (!listed) return indicator;

  return <OverlayTrigger
    placement="right"
    overlay={<Popover className="border">
      <Popover.Body className="small py-2 px-3">
        <ul className="mb-0 ps-3">
          {props.siteNames.map(name => <li key={name}>{name}</li>)}
        </ul>
      </Popover.Body>
    </Popover>}>
    {indicator}
  </OverlayTrigger>;
};
